import React from 'react';
import { withTranslation } from '../../lib/translate';
import Layout from '../../components/layout';
import { connect } from 'react-redux';
import { IonButton, IonIcon, IonItem, IonList } from '@ionic/react';
import { forwardTo } from '../../lib/utils';
import { SmallText, Spacer, StrongText, Title } from '../../components/common';
import moment from 'moment';
import { person } from 'ionicons/icons';
import { getSentGiftVouchers } from '../../store/actions';
import './index.css';
import { ReactComponent as EditIcon } from '../../assets/images/edit-icon.svg';

class SentGiftVouchers extends React.Component {
	componentDidMount() {
		if (this.props.auth.loggedIn) {
			this.props.dispatch(getSentGiftVouchers());
		}
	}

	render() {
		const { __ } = this.props;

		return (
			<Layout showHamburger headerWithTitle title={__('Sent vouchers')} color="transparent">
				<div className="absolute-content scrollable-y flex-row-wrapper">
					<Title className="web-only">{__('Sent vouchers')}</Title>
					<div>
						<IonList className="gift-voucher-history-list box-wrapper">
							{this.props.sentGiftVouchers.map((voucher) => (
								<IonItem
									lines="none"
									key={voucher.id}
									className="pointer"
									onClick={() => {
										forwardTo('/gift-voucher', { voucher, isSent: true, hasEdit: !voucher.redeemed_on });
									}}
								>
									<div style={{flex:'1'}}>
										<StrongText className="ellipsis">{voucher.recipient_email}</StrongText>
										<Spacer size={0} />
										{voucher.redeemed_on ? (
											<SmallText className="gift-voucher-date" color="success">
												{__('Redeemed on')}: {moment(voucher.redeemed_on).format('Do MMM yyyy')}
											</SmallText>
										) : (
											<>
												{voucher.is_sent ? (
													<SmallText className="gift-voucher-date">
														{__('Email sent')}: {moment(voucher.send_on_date).format('Do MMM yyyy')}
													</SmallText>
												) : (
													<SmallText className="gift-voucher-date">
														{__('Scheduled Date')}: {moment(voucher.send_on_date).format('Do MMM yyyy')}
													</SmallText>
												)}
											</>
										)}
									</div>
									{voucher.redeemed_on ? (
										<IonButton style={{ height: '24px' }} color="primary" disabled={true}>
											{__('Redeemed')}
										</IonButton>
									) : (

											<EditIcon className='gift-voucher-resend-button fill-label' />
									)}
								</IonItem>
							))}
						</IonList>
					</div>
					<div className="flex-min">
											<Spacer size={5}/>

						<IonButton color="primary" expand="block" onClick={() => forwardTo('/gift-vouchers')}>
							{__('Send another gift voucher')}
						</IonButton>
					</div>
				</div>
			</Layout>
		);
	}
}

const stateToProps = (state) => {
	return {
		sentGiftVouchers: state.orders.sentGiftVouchers || [],
		auth: state.profile.auth,
	};
};
export default connect(stateToProps)(withTranslation(SentGiftVouchers));
